const cardData = [
  {
    icon: "/assets/webApp/ImgCard1.svg",
    iconStyles: "w-[92.22px] h-[87px]",
    heading: "Custom Mobile App Development",
    paragraph:
      "Your business is unique, and your app should reflect that. We build apps from the ground up, tailored to your goals – whether it’s iOS, Android, or both.",
  },
  {
    icon: "/assets/webApp/ImgCard2.svg",
    iconStyles: "w-[92.22px] h-[87px]",
    heading: "UI/UX Design",
    paragraph:
      "An app should feel as good as it looks. We create clean, intuitive designs that make using your app simple, smooth, and enjoyable.",
  },
  {
    icon: "/assets/webApp/ImgCard3.svg",
    iconStyles: "w-[92.22px] h-[87px]",
    heading: "Cross-Platform Development",
    paragraph:
      "One app, all devices. Our cross-platform solutions save time and cost while giving your users a seamless experience everywhere.",
  },
  {
    icon: "/assets/webApp/ImgCard4.svg",
    iconStyles: "w-[92.22px] h-[87px]",
    heading: "Quality & Ongoing Support",
    paragraph:
      "We don’t just launch and leave. From careful testing before release to updates and improvements after, we make sure your app stays fast, secure, and ready for the future.",
  },
];

const points = [
  { content1: "Fast, smooth performance you can rely on" },
  { content1: "Clean, simple designs that people enjoy using" },
  { content1: "Security baked in from the start" },
  { content1: "Solutions that scale as your business grows" },
  { content1: "A team that’s with you before, during, and after launch" },
];

export { cardData, points };
